/**
 * Maps Balance Sheet Ratios table rows (API `name` keys) onto the shared
 * sector-aware benchmark system.
 */

export const BALANCE_SHEET_RATIOS_PANEL_UNMAPPED = {
    kind: 'notScored',
    reason: 'Unmapped Balance Sheet Ratios row; not scored until a normalized balance-sheet metric is defined.',
};

/** @type {Record<string, { kind: 'scored', metricId: string } | { kind: 'notScored', reason: string }>} */
export const BALANCE_SHEET_RATIOS_PANEL_MAP = {
    debtToEquity: { kind: 'scored', metricId: 'debtToEquity' },
    currentRatio: { kind: 'scored', metricId: 'currentRatio' },
    quickRatio: { kind: 'scored', metricId: 'quickRatio' },
    debtToAssets: { kind: 'scored', metricId: 'debtToAssets' },
    assetTurnover: { kind: 'scored', metricId: 'assetTurnoverRatio' },
    inventoryTurnover: { kind: 'scored', metricId: 'inventoryTurnoverRatio' },
    receivablesTurnover: { kind: 'scored', metricId: 'receivablesTurnoverRatio' },
};

export function getBalanceSheetRatiosPanelMapping(ratioName) {
    if (!ratioName) return BALANCE_SHEET_RATIOS_PANEL_UNMAPPED;
    return BALANCE_SHEET_RATIOS_PANEL_MAP[ratioName] || BALANCE_SHEET_RATIOS_PANEL_UNMAPPED;
}

export const BALANCE_SHEET_RATIOS_PANEL_SCORED_STATUS = new Set(['strong', 'watch', 'weak']);
